import React, { useEffect, useRef, useState } from "react"
import intl from "react-intl-universal"
import CreatableSelect from "react-select/creatable"
import Button from "../../../../atoms/Button"
import styles from "./index.module.scss"
import "./style.css"

export default function MultiSelect({
  label,
  placeholder,
  onSelect,
  opts,
  limitOptsSelected,
  isError,
  messageError,
  onCreateOption,
  isloading,
  type,
  width,
  bIsEdit,
  defaultOptValue,
  bInactiveBtn = false,
  ...rest
}) {
  const [options, setOptions] = useState([])

  const [defaultOption, setDefaultOption] = useState([])

  const [isOpen, setIsOpen] = useState(false)

  const multSelectRef = useRef(null)
  const handleSetValue = async (event, value) => {
    if (!onCreateOption) return
    event.stopPropagation()

    await onCreateOption(value)

    setOptions((oldState) => [...oldState, { label: value, value: value }])
  }

  const handleSeletion = (selecao) => {
    if (type === "semi-quantitativo") {
      setDefaultOption(selecao)
      onSelect(selecao)
      return
    }

    if (
      (type === "qualitativo" || type === "sector") &&
      selecao &&
      selecao.length <= limitOptsSelected
    ) {
      setDefaultOption(selecao)
      onSelect(selecao)
    }
  }

  const [label1, label2] = label?.includes("(Deve ser selecionado")
    ? label.split(" (")
    : ""

  const text = label?.includes("(Deve ser selecionado") ? (
    <label className={styles.label}>
      {label1}
      <span style={{ color: "#737D86" }}> ({label2}</span>
    </label>
  ) : (
    <label>{label}</label>
  )

  useEffect(() => {
    if (bIsEdit) {
      setDefaultOption(defaultOptValue)
    }
  }, [])

  return (
    <div
      className={styles.wrapperCreatableSelect}
      style={{
        width: width ? width : "auto",
      }}
    >
      {text}
      <CreatableSelect
        id={label}
        ref={multSelectRef}
        className={`${styles.multiSelectContainer} ${isError && "borderError"}`}
        classNamePrefix="multiSelect"
        menuIsOpen={isOpen}
        defaultMenuIsOpen={isOpen}
        isMulti
        options={opts}
        placeholder={placeholder}
        isSearchable
        
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
        noOptionsMessage={() => {
          if (opts?.length === 0 || defaultOptValue?.length) {
            return intl.get("ciq.multi_select.no_register")
          } else if (opts?.length === defaultOption?.length) {
            return intl.get("ciq.multi_select.type_to_create")
          } else {
            return intl.get("ciq.multi_select.nomemclature_already_added")
          }
        }}
        value={defaultOption}
        onChange={handleSeletion}
        onCreateOption={(e) => {
          setOptions((oldState) => [
            ...oldState,
            {
              label: e,
              value: e,
            },
          ])
        }}
        defaultValue={{ label: "teste", value: "teste" }}
        // RENDERIZA QUANDO É ESCRITO ALGO
        formatCreateLabel={(e) => {
          return (
            <div className={styles.contentLabel} onClick={(e) => e.stopPropagation()}>
              {bInactiveBtn ? (
                intl.get("ciq.multi_select.there_is_not_term")
              ) : (
                <>
                  <p className={styles.nameNotSearch}>
                    {intl.get("ciq.multi_select.nomenclature_not_found", {
                      nomenclature: ` ${e.trim()} `,
                    })}
                    <br />
                    {intl.get("ciq.multi_select.can_add_nomenclature")}
                  </p>

                  <Button
                    className={styles.buttonCreate}
                    variant="outline"
                    onClick={(evt) => handleSetValue(evt, e.trim())}
                    isLoading={isloading}
                  >
                    {intl.get("ciq.multi_select.add_nomenclature")}
                  </Button>
                </>
              )}
            </div>
          )
        }}
        {...rest}
      />

      {isError && <span className={styles.error}>{messageError}</span>}
    </div>
  )
}
